import { Injectable } from '@angular/core';
import { MainNavItem } from '../types/navigation';
import { Observable, of } from 'rxjs';
import { Permissions } from './user-permission.service';

@Injectable({
  providedIn: 'root'
})
export class SiteService {

  constructor() { }

  getMainNav(): Observable<MainNavItem[]> {
    // `permission` mirrors each route's requirePermission guard (any one grants the item). Items with
    // neither `permission` nor `role` are open to any signed-in user. MainNavComponent filters this list
    // against the current user's permissions/roles.
    const nav: MainNavItem[] = [
      { name: "My Dashboard", path: "/dashboard", icon: "/assets/images/brand.png" },
      { name: "Calendar", path: "/calendar", icon: "/assets/images/history.png" },
      { name: "Vehicle Checklist", path: "/checklist", icon: "/assets/images/maintenance.png" },
      { name: "Regions", path: "/regions", icon: "/assets/images/region.png", permission: [Permissions.RegionsView, Permissions.RegionsEdit] },
      { name: "Brands", path: "/divisions", icon: "/assets/images/division.png", permission: [Permissions.DivisionsView, Permissions.DivisionsEdit] },
      {
        name: "Vehicle Maintenance",
        path: "/maintenance",
        icon: "/assets/images/brand.png",
        queryParams: { view: "favorites" },
        permission: [Permissions.VehiclesView, Permissions.VehiclesEdit],
      },
      { name: "RPO Maintenance", path: "/rpos", icon: "/assets/images/rpo.png", permission: [Permissions.RposView, Permissions.RposEdit] },
      { name: "CFD Maintenance", path: "/cfds", icon: "/assets/images/rpo.png", permission: [Permissions.CfdsView, Permissions.CfdsEdit] },
      { name: "Uploads", path: "/uploads", icon: "/assets/images/maintenance.png", permission: [Permissions.FilesView, Permissions.FilesEdit] },
      { name: "History", path: "/history", icon: "/assets/images/history.png" },
      { name: "Manage Roles", path: "/roles", icon: "/assets/images/roles.png", permission: Permissions.RolesEdit },
      { name: "Manage Users", path: "/users", icon: "/assets/images/users.png", permission: Permissions.UsersEdit },
      { name: "Data Update Maintenance", path: "/data-updates", icon: "/assets/images/maintenance.png", permission: [Permissions.DataMaintenanceView, Permissions.DataMaintenanceEdit] },
      { name: "Data Exports", path: "/data-exports", icon: "/assets/images/export.png", permission: [Permissions.DataExportsView, Permissions.DataExportsImport, Permissions.DataExportsDistributionUpdatesView, Permissions.DataExportsTranslationBatchView, Permissions.DataExportsCfdVehicleReportsView, Permissions.DataExportsRpoVehicleReportsView] },
      { name: "System", path: "/system", icon: "/assets/images/system.png" },
      { name: "Style Guide", path: "/system/style-guide", icon: "/assets/images/style-guide.png", role: "SystemAdmin" }
    ];

    return of(nav);
  }
}
